import styled from 'styled-components';

export const StyledComparisonChart = styled.div`
  align-items: center;
  background-color: ${props => props.theme.colors.get(props.background)};
  display: flex;
  flex-direction: column;
`;

export const Container = styled.div`
  align-items: center;
  color: ${props => props.theme.colors.text.secondary};
  display: flex;
  flex-direction: column;
  max-width: 850px;
  padding: ${props => props.theme.spacing(14, 4)};
  width: 100%;

  @media ${props => props.theme.tablet} {
    padding: ${props => props.theme.spacing(20, 5)};
  }
`;

export const Header = styled.h2`
  ${props => props.theme.typography.heading2}
  text-align: center;
  margin-bottom: ${props => props.theme.spacing(8)};
  @media ${props => props.theme.laptop} {
    margin-bottom: ${props => props.theme.spacing(3)};
  }
`;

export const Content = styled.div`
  align-items: flex-end;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const ChartBrands = styled.div`
  display: flex;
  justify-content: space-between;
  padding: ${props => props.theme.spacing(4, 2)};
  width: 8.25rem;

  @media ${props => props.theme.tablet} {
    padding: ${props => props.theme.spacing(5, 6)};
    width: 10.25rem;
  }

  @media ${props => props.theme.laptop} {
    justify-content: flex-end;
    width: 25%;
  }
`;

export const BrandsWrapper = styled.div`
  align-items: flex-end;
  display: flex;
  flex-basis: 110px;
  max-width: 184px;
  justify-content: space-between;
  width: 100%;

  @media ${props => props.theme.laptop} {
    flex-basis: 150px;
  }
`;

export const Brand = styled.span`
  ${props => props.theme.typography.label}
  display: inline-block;
  max-width: 65px;

  @media ${props => props.theme.tablet} {
    ${props => props.theme.typography.label}
    text-align: center;
  }
`;

export const LogoImg = styled.img``;

export const ChartItems = styled.div`
  width: 100%;
`;

// Comparison Chart Item Styles
export const StyledComparisonChartItem = styled.div`
  border-radius: 30px;
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
  min-height: 80px;
  padding: ${props => props.theme.spacing(5, 6)};

  &:nth-child(odd) {
    background-color: ${props => props.theme.colors.neutral.bone};
  }

  @media ${props => props.theme.tablet} {
    border-radius: 100px;
    padding: ${props => props.theme.spacing(4, 10)};
  }
`;

export const ChartItemHeader = styled.div`
  flex: 1 1 75%;
  padding-right: ${props => props.theme.spacing(5)};

  @media ${props => props.theme.laptop} {
    flex-basis: 60%;
  }
`;

export const HeaderThree = styled.h6`
  ${props => props.theme.typography.heading6}
  font-weight: bold;
`;

export const Paragraph = styled.p`
  ${props => props.theme.typography.body};

  @media ${props => props.theme.laptop} {
    ${props => props.theme.typography.button}
  }
`;

export const ChartItemIcons = styled.div`
  display: flex;
  flex: 0 0 100px;
  justify-self: flex-end;
  justify-content: space-between;
  @media ${props => props.theme.laptop} {
    flex-basis: 135px;
  }
`;
